import { api, Api } from "@api/bot-base-api-request.ts";
import { useQuery } from "@tanstack/react-query";
import { BotWalletSupportedChain } from "@providers/wallet";

const BOT_GET_REFERRAL_INFO_QUERY_KEY = "bot-get-referral-info";

type BotGetReferralInfoParams = {
  appPubKey: string;
  userId: string;
  chainId: BotWalletSupportedChain;
};

interface BotReferralInfoResponse {
  referringUserId?: string;
  referalsCount: number;
  referralRewards?: { refEarned: number };
}

const fetchBotReferralInfo = async (
  api: Api,
  params: BotGetReferralInfoParams,
): Promise<BotReferralInfoResponse> =>
  api.get("getReferralInfo", { searchParams: params }).json();

const useBotReferralInfo = <TData = BotReferralInfoResponse>(
  params: BotGetReferralInfoParams,
) =>
  useQuery<BotReferralInfoResponse, Error, TData>({
    queryKey: [BOT_GET_REFERRAL_INFO_QUERY_KEY, params],
    queryFn: async () => fetchBotReferralInfo(api, params),
  });

export {
  useBotReferralInfo,
  fetchBotReferralInfo,
  BOT_GET_REFERRAL_INFO_QUERY_KEY,
};
